import DigitalSignature from '@/components/digital-signature/DigitalSignatureModal.vue';

let VueComponent;
let component;

function close() {
  if (!component) return;
  component.show = false;
  component.$destroy();
}

function open(signFn, props = {}) {
  component = new VueComponent();

  Object.keys(props).forEach((key) => {
    component[key] = props[key];
  });

  component.show = true;
  component.sign = signFn;
  component.$on('close', close);

  component.$mount();
}

export default function install(Vue) {
  VueComponent = Vue.extend(DigitalSignature);

  Object.defineProperty(Vue.prototype, '$digitalSignature', {
    get() {
      return { open, close };
    },
  });
}
